import cn from 'classnames'
import * as React from 'react'

import styles from './cover-video.module.scss'

// Had to refactor this component to use an effect hook an ref and manually set props
// b/c react omitts muted from dom, wich means the video doesn't render on first page view
const VideoComponent = ({
  className,
  muted = true,
  autoPlay = true,
  loop = true,
  playsInline = true,
  src,
  poster,
  onEnded,
}: { onEnded?: () => void } & React.VideoHTMLAttributes<HTMLVideoElement>) => {
  const videoContainer = React.createRef<HTMLDivElement>()
  React.useEffect(() => {
    const node = videoContainer.current

    if (node) {
      const video = window.document.createElement('video')
      video.className = cn(styles.root, className)
      video.autoplay = autoPlay
      video.loop = loop
      video.muted = muted
      video.setAttribute('playsinline', playsInline.toString()) // fixes autoplay in webkit (ie. mobile safari)
      if (src) {
        video.src = src
      }
      if (poster) {
        video.poster = poster
      }
      if (onEnded) {
        video.onended = onEnded
      }
      node.innerHTML = ''
      node.appendChild(video)
    }
  }, [autoPlay, className, loop, muted, onEnded, playsInline, poster, src, videoContainer])

  return <div ref={videoContainer} />
}

export default VideoComponent
